const fields = {
  icon: '{861EF6C6-8458-4065-B901-8D1BFFEEA850}',
  isMobile: '{9D5649C1-CC99-473E-AF6F-12BCAC560493}',
};

const socialMediaBarFields = {
  socialMedia: '{954B5A22-1F67-447F-8B6E-2A773520DFB3}',
  postText: '{F3DC7E48-B908-4EA4-A91A-8D3AD3A207DA}',
};

const imagefields = {
  mobileImage: '{FDCA82BE-9277-47E0-8137-FC3D0DD365DA}',
  image: '{4E9D2DE7-3ABB-4AB0-B276-8EA3D8E15AD2}',
};

const EE_EMPTY_IMAGE_FALLBACK_CLASS_NAME = 'scEmptyImage';

const EE_EMPTY_DATE_FALLBACK_VALUE = '0001-01-01T00:00:00';

export { imagefields, EE_EMPTY_IMAGE_FALLBACK_CLASS_NAME, EE_EMPTY_DATE_FALLBACK_VALUE, socialMediaBarFields };

export default fields;
